import React from "react";
import { useContext } from "react";
import { I18nReactContext } from "../../../../../contexts/I18nContext";
import { Button } from "../../../../Form/Button/Button";
import { Modal } from "../../../../Smart/Modal/Modal";
import { buttonColors } from "../../../../Pickers/InputTheme";
import failedExamHive from '../../../../../assets/images/session/failed-exam-hive.png';
import './QuestionnaireFailureModal.scss';

export const QuestionnaireFailureModal = ({ 
    open, 
    onClose, 
    onGoHome 
}) => {
    const { i18n } = useContext(I18nReactContext);

    return (
        <Modal
            open={open}
            onClose={onClose}>
            <div className="failure-modal-content">
                <div className="failure-container">
                    <div className="hive-background">
                        <img src={failedExamHive} alt="hive background" className="hive-image" />
                    </div>
                    <div className="failure-text">
                        <h1 className="main-failure">{i18n.translate('questionnaireSession.finishModal.oopsTitle')}</h1>
                        <p className="sub-failure">{i18n.translate('questionnaireSession.finishModal.oopsMessage')}</p>
                    </div>
                    <div className="failure-action">
                        <Button
                            color={buttonColors.YELLOW}
                            onClick={onGoHome}
                            text={i18n.translate('questionnaireSession.buttons.oopsBackToHomePage')}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
} 